export default "__VITE_ASSET__CjwI_pPq__"